import { render, staticRenderFns } from "./capital-tile.vue?vue&type=template&id=199f3dce&scoped=true&"
import script from "./capital-tile.vue?vue&type=script&lang=ts&"
export * from "./capital-tile.vue?vue&type=script&lang=ts&"
import style0 from "./capital-tile.vue?vue&type=style&index=0&id=199f3dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f3dce",
  null
  
)

export default component.exports